import { useTaskListContext } from "../context/taskListContext";

export const useKeyDown = ({ searchData }: { searchData: Function }) => {
	const {
		actions: { setSearchText, setDownHours },
	} = useTaskListContext();

	const onKeyDownSearchText = (e: any) => {
		if (e.keyCode === 13) {
			setSearchText(e.target.value);
			searchData();
		}
	};

	const onKeyDownDownHours = (e: any) => {
		if (e.keyCode === 13) {
			setDownHours(e.target.value);
			searchData();
		}
	};

	return { onKeyDownSearchText, onKeyDownDownHours };
};
